import * as ReactService from "@intech/react-service";
import { WebEventoDocumentoEntidade, WebEventoEntidade } from "../entidades";

class Evento extends ReactService.BaseService {
  constructor() {
    super("Evento");
  }

  BuscarTodos = () =>
    this.CreateRequest<WebEventoEntidade[]>(ReactService.RequestType.GET, `BuscarTodos`);

  BuscarDocumentos = (oidEvento: number) =>
    this.CreateRequest<WebEventoDocumentoEntidade[]>(ReactService.RequestType.GET, `BuscarDocumentos/${oidEvento}`);

}

export const EventoService = new Evento();
